import { isDateBefore, isDateValid } from '../../../utils/dates/date.utils';

export const getYearDropDownOptions = (...args) => {

    const [
        serverDate,
        oepStartDate,
        coverageYear,
        exchangeStartYear,
    ] = args;

    let totalYears = 0;
    switch(true) {
        case !isDateValid(serverDate, 'YYYY-MM-DD') || !isDateValid(oepStartDate, 'YYYY-MM-DD'):
            break;
        case typeof coverageYear !== 'number' || typeof exchangeStartYear !== 'number':
            break;
        case isDateBefore(serverDate, oepStartDate):
            totalYears = coverageYear - exchangeStartYear;
            break;
        default:
            totalYears = coverageYear - exchangeStartYear + 1;
    }
    return Array.from({ length: totalYears }, (_, i) => i + exchangeStartYear);
};